import { Accordion, AccordionDetails, AccordionSummary, Checkbox, FormControl, FormControlLabel, FormGroup, FormHelperText, Paper, Tooltip } from '@mui/material'
import React from 'react'
import { useSelector } from 'react-redux'
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { checkRole, checkProjects, checkPermissions, isRoleSelected, isPermissionSelected, checkProject } from './edit-user-actions';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import LanguageIcon from '@mui/icons-material/Language';

const EditUserPermissions = () => {

    const state = useSelector(state => state.pages.editUser)

    return (
        <div className="p-8">
            <div className="grid gap-4">
                <Accordion defaultExpanded={true}>
                    <AccordionSummary className="!bg-gray-100" expandIcon={<ExpandMoreIcon />}>
                        <div>
                            <div className="flex items-center gap-2"><LanguageIcon fontSize="small" /> <span>Global Permissions</span></div>
                            <small className="text-gray-700 pl-8"><em>Global permissions are applied to all projects and be used with caution.</em></small>
                        </div>
                    </AccordionSummary>
                    <AccordionDetails>
                        <div className="grid gap-8 p-4">
                            <div className="grid md:grid-cols-3 gap-4">
                                <div className="">
                                    <p>Roles</p>
                                    <small className="text-gray-700"><em>The user will be able to access the roles selected</em></small>
                                </div>
                                <Paper className="p-4 flex-1 !bg-gray-100 col-span-2">
                                    {state.roles.filter(r => r.global).map((rol, index) => (
                                        <FormControl key={rol.name} disabled={state.master} fullWidth>
                                            <FormControlLabel
                                                name={rol.name}
                                                disabled={state.master}
                                                control={<Checkbox disabled={state.master} />}
                                                checked={isRoleSelected(null, rol.name)}
                                                label={<div className="flex items-center">
                                                    <span className="uppercase">{rol.value}</span>
                                                    <Tooltip className="ml-2" title={rol.detail}>
                                                        <HelpOutlineIcon fontSize="small" />
                                                    </Tooltip>
                                                </div>}
                                                onClick={e => checkRole(e, null, rol.name)}
                                                labelPlacement="end"
                                            />
                                            <FormHelperText>{rol.descripcion}</FormHelperText>
                                        </FormControl>
                                    ))}
                                </Paper>
                            </div>
                            <div className="grid md:grid-cols-3 gap-4 border-gray-200">
                                <div>
                                    <p>Permissions</p>
                                    <small className="text-gray-700"><em>Select the user permissions</em></small>
                                </div>
                                <Paper className="p-4 flex-1 !bg-gray-100 col-span-2">
                                    {state.permissions.filter(p => p.global).map((permission, index) => (
                                        <FormControl key={permission.name} fullWidth>
                                            <FormControlLabel
                                                name={permission.name}
                                                value={{ project: null, permission: permission.name }}
                                                labelPlacement="end"
                                                disabled={state.master}
                                                control={<Checkbox />}
                                                checked={isPermissionSelected(null, permission.name)}
                                                label={<p className="uppercase">{permission.value}</p>}
                                                onClick={e => checkPermissions(e, null, permission.name)}
                                            />
                                            <FormHelperText>{permission.descripcion}</FormHelperText>
                                        </FormControl>
                                    ))}
                                </Paper>
                            </div>
                        </div>
                    </AccordionDetails>
                </Accordion>

                <div className='grid gap-2 my-8'>
                    <p className="text-lg font-bold">Project Permissions</p>
                    <p className="text-gray-700 text-sm"><em>Select the projects where the user will have access</em></p>
                </div>
                {state.projects.map((project, index) => (
                    <Accordion key={project.name} expanded={project.selected} >
                        <AccordionSummary className="!bg-gray-100" expandIcon={<ExpandMoreIcon />} >
                            <div onClick={e => e.stopPropagation()}>
                                <div>
                                    <FormControl variant="outlined" size="small" >
                                        <FormControlLabel
                                            labelPlacement="end"
                                            label={<div className="flex items-center gap-2"><AccountTreeIcon fontSize="small" /> <span>{project.name}</span></div>}
                                            control={
                                                <Checkbox
                                                    disabled={state.master}
                                                    name={project.name}
                                                    checked={project.selected}
                                                    onChange={(e) => { checkProject(e, index) }}
                                                />
                                            }
                                        />
                                    </FormControl>
                                </div>

                                <small className="text-gray-700 pl-8"><em>This permissions are applied only to the project {project.name}</em></small>
                            </div>
                        </AccordionSummary>
                        <AccordionDetails>
                            <div className="grid gap-8 p-4">
                                <div className="grid md:grid-cols-3 gap-4">
                                    <div className="">
                                        <p>Roles</p>
                                        <small className="text-gray-700"><em>The user will be able to access the roles selected</em></small>
                                    </div>
                                    <Paper className="p-4 flex-1 !bg-gray-100 col-span-2">
                                        {state.roles.filter(r => !r.global).map((rol, index) => (
                                            <FormControl key={rol.name} disabled={state.master} fullWidth>
                                                <FormControlLabel
                                                    name={`${project.name}:${rol.name}`}
                                                    value={{ project: project.name, rol: rol.name }}
                                                    disabled={state.master}
                                                    control={<Checkbox disabled={state.master} />}
                                                    checked={isRoleSelected(project.name, rol.name)}
                                                    label={<div className="flex items-center">
                                                        <span className="uppercase">{rol.value}</span>
                                                        <Tooltip className="ml-2" title={rol.detail}>
                                                            <HelpOutlineIcon fontSize="small" />
                                                        </Tooltip>
                                                    </div>}
                                                    onClick={e => checkRole(e, project.name, rol.name)}
                                                    labelPlacement="end"
                                                />
                                                <FormHelperText>{rol.descripcion}</FormHelperText>
                                            </FormControl>
                                        ))}
                                    </Paper>
                                </div>
                                <div className="grid md:grid-cols-3 gap-4 border-gray-200">
                                    <div>
                                        <p>Permissions</p>
                                        <small className="text-gray-700"><em>Select the user permissions</em></small>
                                    </div>
                                    <Paper className="p-4 flex-1 !bg-gray-100 col-span-2">
                                        {state.permissions.filter(p => !p.global).map((permission, index) => (
                                            <FormControl key={permission.name} fullWidth>
                                                <FormControlLabel
                                                    name={`${project.name}:${permission.name}`}
                                                    value={{ project: project.name, permission: permission.name }}
                                                    labelPlacement="end"
                                                    disabled={state.master}
                                                    control={<Checkbox />}
                                                    checked={isPermissionSelected(project.name, permission.name)}
                                                    label={<p className="uppercase">{permission.value}</p>}
                                                    onClick={e => checkPermissions(e, project.name, permission.name)}
                                                />
                                                <FormHelperText>{permission.descripcion}</FormHelperText>
                                            </FormControl>
                                        ))}
                                    </Paper>
                                </div>
                            </div>
                        </AccordionDetails>
                    </Accordion>
                ))}
            </div>
        </div>
    )
}

export default EditUserPermissions
